import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { EffectsModule } from "@ngrx/effects";
import { StoreModule } from "@ngrx/store";
import { AuthorizationModule } from "../authorization/authorization.module";
import { I18nModule } from "../i18n/i18n.module";
import { KendoModule } from "../kendo/kendo.module";
import { BypassSecurityPipe } from "../pipes/bypassSecurity.pipe";
import { CanEditStepPipe } from "../pipes/canEditStep.pipe";
import { CanWorkStepPipe } from "../pipes/canWorkStep.pipe";
import { DebugPipe } from "../pipes/debug.pipe";
import { MetadataSortPipe } from "../pipes/metadataSort.pipe";
import { ECEButtons } from "./buttons";
import { ChromeComponent } from "./chrome/chrome.component";
import { DialogComponent } from "./dialog/dialog.component";
import { FilterGroupComponent } from "./filter-group/filter-group.component";
import { HelpLinkComponent } from "./help-link/help-link.component";
import { SwitchComponent } from "./inputs/switch/switch.component";
import { LoaderComponent } from "./loader/loader.component";
import { MenuShellComponent } from "./menu/menu-shell/menu-shell.component";
import { NavComponent } from "./menu/nav/nav.component";
import { TopBarComponent } from "./menu/top-bar/top-bar.component";
import { PersonComponent } from "./person/person.component";
import { PersonFromLoginComponent } from "./personFromLogin/personFromLogin.component";
import {
  CircPeoplePickerComponent,
  PeopleSelectComponent,
  SpPeoplePickerComponent
} from "./pickers";
import { PeoplePickerComponent } from "./pickers/people-picker/people-picker.component";
import { featureName } from "./state";
import { PersonEffects } from "./state/person.effects";
import { personReducer } from "./state/person.reducer";
import { StepIcons } from "./step-icon";

@NgModule({
  imports: [
    I18nModule,
    AuthorizationModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    KendoModule,
    RouterModule.forChild([]),
    StoreModule.forFeature(featureName, personReducer),
    EffectsModule.forFeature([PersonEffects])
  ],
  declarations: [
    CanEditStepPipe,
    CanWorkStepPipe,
    LoaderComponent,
    PersonComponent,
    SpPeoplePickerComponent,
    PeopleSelectComponent,
    BypassSecurityPipe,
    PersonFromLoginComponent,
    ChromeComponent,
    FilterGroupComponent,
    TopBarComponent,
    MenuShellComponent,
    NavComponent,
    ...ECEButtons,
    HelpLinkComponent,
    PeoplePickerComponent,
    CircPeoplePickerComponent,
    ...StepIcons,
    DebugPipe,
    MetadataSortPipe,
    SwitchComponent,
    DialogComponent
  ],
  exports: [
    I18nModule,
    LoaderComponent,
    PersonComponent,
    SwitchComponent,
    SpPeoplePickerComponent,
    CircPeoplePickerComponent,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    KendoModule,
    CanEditStepPipe,
    CanWorkStepPipe,
    BypassSecurityPipe,
    PersonFromLoginComponent,
    DialogComponent,
    NavComponent,
    TopBarComponent,
    ChromeComponent,
    FilterGroupComponent,
    MenuShellComponent,
    RouterModule,
    ...ECEButtons,
    HelpLinkComponent,
    ...StepIcons,
    DebugPipe,
    MetadataSortPipe
  ]
})
export class CircCommonModule {}
